import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaiementSuccesPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const storeId = searchParams.get("store_id");

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center space-y-6">
                <CheckCircle2 className="h-16 w-16 text-green-500 mx-auto" />
                <h2 className="text-2xl font-bold text-gray-900">Paiement réussi !</h2>
                <p className="text-gray-600 text-sm">
                    Votre paiement a été confirmé. Votre boutique est en attente de validation par notre équipe.
                </p>
                <div className="flex flex-col gap-3 pt-2">
                    {storeId && (
                        <Button
                            className="w-full bg-orange-500 hover:bg-orange-600"
                            onClick={() => navigate(`/seller/dashboard/${storeId}`)}
                        >
                            Accéder à mon dashboard
                        </Button>
                    )}
                    <Button variant="outline" className="w-full" onClick={() => navigate("/mes-boutiques")}>
                        Voir mes boutiques
                    </Button>
                </div>
            </div>
        </div>
    );
}
